var Vue = require('vue');
var Util = require('./utilities');
var urlUtilities = require('utilities/urlUtilities');
var metadataUtils = require('metadata-utils');
var stringUtilities = require('utilities/stringUtilities');
var getOrdinal = metadataUtils.getOrdinal;

// if this starts getting complicated (lots of formats, or needs internationalization), then
// consider numeral.js
Vue.filter('commaGrouping', function (v) {
	return stringUtilities.formatNumber(v);
});

Vue.filter('length', function (v) {
	if (!v) {
		return 0;
	}

	return v instanceof Array ? v.length : Object.keys(v).length;
});

Vue.filter('date', Util.getSimpleDateString);

Vue.filter('dateShort', Util.getShortDateString);

Vue.filter('time', Util.getSimpleTimeString);

Vue.filter('timetz', Util.getSimpleTimeStringTZ);

Vue.filter('ago', function (val) {
	return typeof val === 'undefined' ? 'Never' : Util.getElapsedTimeString(val);
});

Vue.filter('join', function (val) {
	return val.join();
});

Vue.filter('asset', urlUtilities.assetUrl);

function getGradesFromMetadata(grades) {
	if (!grades || !grades.length) {
		return '';
	}
	// Remove pre-k, as it's erroneous on products
	let gradeList = grades.filter(g => g !== 191923).sort();
	let gradeStrings = metadataUtils.gradesToStrings(gradeList);

	// Split ranges into singular grades
	gradeStrings = gradeStrings.reduce((acc, g) => {
		let val = [g];
		if (g.indexOf('-') !== -1) {
			val = g.split('-');
		}
		return acc.concat(val);
	}, []);

	return gradeStrings;
}

// Takes grade metdata ID list and returns a grade range string
Vue.filter('getGradeRangeString', function (grades) {
	const gradeStrings = getGradesFromMetadata(grades);

	if (gradeStrings.length === 0) {
		return '';
	} else if (gradeStrings.length === 1) {
		return gradeStrings[0];
	}

	return gradeStrings[0] + '-' + gradeStrings[gradeStrings.length - 1];
});

Vue.filter('getGradeRangeWithOrdinal', function (grades) {
	let gradeStrings = getGradesFromMetadata(grades);
	let gradeRange = getOrdinal(gradeStrings[0]);

	if (gradeStrings.length > 1) {
		gradeRange += '-';
		gradeRange += getOrdinal(gradeStrings[gradeStrings.length - 1]);
	}

	return gradeRange;
});

Vue.filter('prettyJson', function (s) {
	return JSON.stringify(s, null, '\t');
});
